import { useState } from 'react';
import { getPersistedToken } from '@koala/sdk/v4';
import { useDispatch } from 'react-redux';
import * as Styled from './styles';
import { Modal } from '@/components/uielements/modal';
import { __DANGEROUS_EMPTY_REQUEST_ORIGIN, getOrigin } from '@/utils';
import { useGlobalDispatch } from '@/redux/global/reducer';
import authActions from '@/redux/auth/actions';
import { PrimaryButton } from '@/components/uielements/primaryButton/styles';
import { createHttpClientWithToken } from '@/services/client';

const DeleteAccount = () => {
  const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const dispatch = useDispatch();
  const { displayErrorToast } = useGlobalDispatch();

  const sendDeleteRequest = async () => {
    let origin: string;
    if (typeof window !== 'undefined') {
      origin = getOrigin(window.location.host);
    } else {
      origin = getOrigin(__DANGEROUS_EMPTY_REQUEST_ORIGIN);
    }
    const token = getPersistedToken({ origin });
    const client = createHttpClientWithToken({ origin, token });
    const uri = '/v1/ordering/loyalty/me/delete';
    const data = await client.delete(uri).res();
    return data;
  };

  const handleDelete = async () => {
    try {
      const response = await sendDeleteRequest();
      setShowDeleteAccountModal(false);
      if (response.ok) {
        setShowConfirmationModal(true);
        dispatch(authActions.logout());
      } else {
        const errorMessage =
          'Sorry, something went wrong. We were not able to delete your account.';
        dispatch(displayErrorToast(errorMessage));
      }
    } catch (e) {
      const errorMessage = 'Sorry, something went wrong. We were not able to delete your account.';
      dispatch(displayErrorToast(errorMessage));
      setShowDeleteAccountModal(false);
    }
  };

  return (
    <div>
      <PrimaryButton onClick={() => setShowDeleteAccountModal(true)}>Delete Account</PrimaryButton>

      {/* Delete Confirmation Modal */}
      {showDeleteAccountModal && (
        <Modal.Container
          onCancel={() => setShowDeleteAccountModal(false)}
          requestVisibility={showDeleteAccountModal}
        >
          {() => (
            <>
              <Styled.DeleteModalHeader>Are You Sure You Want To Delete?</Styled.DeleteModalHeader>

              <Styled.ModalContent>
                <Styled.ModalBody>
                  By confirming, you agree to delete your account, which will result in all data and
                  account details being lost.
                </Styled.ModalBody>
              </Styled.ModalContent>
              <Styled.ModalFooter>
                <Styled.DeleteButton onClick={handleDelete}>Confirm & Delete</Styled.DeleteButton>
                <Modal.Cancel onClick={() => setShowDeleteAccountModal(false)}>Cancel</Modal.Cancel>
              </Styled.ModalFooter>
            </>
          )}
        </Modal.Container>
      )}

      {/* Success Confirmation Modal */}
      {showConfirmationModal && (
        <Modal.Container
          onCancel={() => setShowConfirmationModal(false)}
          requestVisibility={showConfirmationModal}
        >
          {() => (
            <>
              <Styled.ConfirmationModalHeader>
                Account Has Been Deleted
              </Styled.ConfirmationModalHeader>
              <Styled.ModalFooter>
                <Styled.ConfirmationButton onClick={() => setShowConfirmationModal(false)}>
                  OK
                </Styled.ConfirmationButton>
              </Styled.ModalFooter>
            </>
          )}
        </Modal.Container>
      )}
    </div>
  );
};

export default DeleteAccount;
